import React, { useEffect, useState } from 'react';

import {
  EuiFlyout,
  EuiFlyoutHeader,
  EuiFlyoutBody,
  EuiFlyoutFooter,
  EuiButton,
  EuiTitle,
  EuiFlexGroup,
  EuiFlexItem,
} from '@elastic/eui';
import UsuariosDelegadoContainer from './container';
import './styles.css';

export const SelectorUsuarioParte = (props) => {
  const {title, user, onChangeUser, currentUser, type} = props;

  const [isFlyoutVisible, setIsFlyoutVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(user)

  const closeFlyout = () => setIsFlyoutVisible(false);
  const showFlyout = () => setIsFlyoutVisible(true);

  const onAccept = () => {setIsFlyoutVisible(false); onChangeUser(selectedUser)}
  const onSelect = (value) => setSelectedUser(value);

  useEffect(()=>{},[user,type])

  let flyout;
  if (isFlyoutVisible) {
    flyout = (
      <EuiFlyout
        ownFocus
        onClose={closeFlyout}
        size='s'
        aria-labelledby="flyoutLargeTitle">
        <EuiFlyoutHeader hasBorder>
          <EuiTitle size="m">
            <h2 id="flyoutLargeTitle">{`${title}`}</h2>
          </EuiTitle>
        </EuiFlyoutHeader>
        <EuiFlyoutBody>
          <UsuariosDelegadoContainer onSelect={type==='DEL' ? undefined : onSelect} selected={selectedUser} currentUser={currentUser} type={type}/>
        </EuiFlyoutBody>
        {type!=='DEL' ? 
        <EuiFlyoutFooter>
          <EuiFlexGroup justifyContent="spaceBetween">
            <EuiFlexItem grow={false}>
              <EuiButton
                iconType="cross"
                onClick={()=>closeFlyout()}
                flush="left">
                Cancelar
              </EuiButton>
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
              <EuiButton onClick={()=>onAccept()} fill>
                Aceptar
              </EuiButton>
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlyoutFooter>
        :null}
      </EuiFlyout>
    );
  }
  return (
    <div>
      <EuiButton onClick={showFlyout} iconType="user" color='primary' size={'s'} className='btnParteUser'>{type==='DEL' ? 'Ver Delegados' : user.login}</EuiButton>
      {flyout}
    </div>
  );
};